import Vue from 'vue';


const {router} = Vue;


export const switchRoom = async (roomId) => {
  const route = router.currentRoute;
  if (route.path !== '/share' || route.query.room !== roomId) {
    await router.replace({path: '/share', query: {room: roomId}});

    // Wait until room is connected.
    await new Promise((resolve) => {
      const unwatch = Vue.store.watch(
          () => Vue.store.getters['share/getRoom'],
          (room) => {
            if (room?.id === roomId) {
              unwatch();
              resolve();
            }
          }
      );
    });
  }
};
